module.exports = __webpack_public_path__ + "static/media/green.b60d7fa4.ogg";